import { LinksElementSchema } from '../../schema/pageElements.val';
import BlankLink from '../BlankLink/BlankLink';

interface LinksElementProps {
  links: LinksElementSchema['links'];
}

const LinksElement: React.FC<LinksElementProps> = ({ links }) => {
  return (
    <div className="w-full flex flex-col gap-24 laptop:px-128 items-start">
      {links.map((link, index) => {
        return <BlankLink key={index} href={link.href} linkText={link.text} />;
      })}
    </div>
  );
};

export default LinksElement;
